module.exports = require("@pb/kit-hook-use-arrow-navigation");